import {nanoid} from 'nanoid'

export const types = [
  {label: '最新', value: '1'},
  {label: '推荐', value: '2'}
]

export const classify = [
  {
    label: '术式方案',
    bannerCode: 'LIBRARY_1',
    iconPath: require('../../assets/images/technology/tab1-icon.png'),
    activeIconPath: require('../../assets/images/technology/tab1-icon-active.png'),
    iconBgPath: require('../../assets/images/technology/rectangle_default.png'),
    activeIconBgPath: require('../../assets/images/technology/rectangle_active_1.png'),
    listBg: require('../../assets/images/technology/list-bg-1.png'),
    value: '术式方案',
    nanoid: nanoid(),
    children: [
      {label: '全部', value: '', nanoid: nanoid()},
      {label: '房颤', value: '房颤', nanoid: nanoid()},
      {label: '房速/房扑', value: '房速/房扑', nanoid: nanoid()},
      {label: '室速', value: '室速', nanoid: nanoid()},
      {label: '室上速', value: '室上速', nanoid: nanoid()},
      {label: '左心耳封堵', value: '左心耳封堵', nanoid: nanoid()},
      {label: '创新故事', value: '创新故事', nanoid: nanoid()},
      {label: '其他', value: '其他', nanoid: nanoid()},
    ]
  },
  {
    label: '技术前沿',
    bannerCode: 'LIBRARY_2',
    iconPath: require('../../assets/images/technology/tab2-icon.png'),
    activeIconPath: require('../../assets/images/technology/tab2-icon-active.png'),
    iconBgPath: require('../../assets/images/technology/rectangle_default.png'),
    activeIconBgPath: require('../../assets/images/technology/rectangle_active_2.png'),
    listBg: require('../../assets/images/technology/list-bg-2.png'),
    value: '技术前沿',
    nanoid: nanoid(),
    children: [
      {label: '全部', value: '', nanoid: nanoid()},
      {label: '最新技术介绍', value: '最新技术介绍', nanoid: nanoid()},
      {label: '最美珊瑚链', value: '最美珊瑚链', nanoid: nanoid()},
      {label: '文献解读', value: '文献解读', nanoid: nanoid()},
    ]
  },
  {
    label: '专科发展',
    bannerCode: 'LIBRARY_3',
    iconPath: require('../../assets/images/technology/tab4-icon.png'),
    activeIconPath: require('../../assets/images/technology/tab4-icon-active.png'),
    iconBgPath: require('../../assets/images/technology/rectangle_default.png'),
    activeIconBgPath: require('../../assets/images/technology/rectangle_active_4.png'),
    listBg: require('../../assets/images/technology/list-bg-4.png'),
    value: '专科发展',
    nanoid: nanoid(),
    children: []
  },
  {
    label: '诊疗发展',
    bannerCode: 'LIBRARY_4',
    iconPath: require('../../assets/images/technology/tab5-icon.png'),
    activeIconPath: require('../../assets/images/technology/tab5-icon-active.png'),
    iconBgPath: require('../../assets/images/technology/rectangle_default.png'),
    activeIconBgPath: require('../../assets/images/technology/rectangle_active_5.png'),
    listBg: require('../../assets/images/technology/list-bg-5.png'),
    value: '诊疗发展',
    nanoid: nanoid(),
    children: [
      {label: '全部', value: '', nanoid: nanoid()},
      {label: '路径优化', value: '路径优化', nanoid: nanoid()},
      {label: '获益传递', value: '获益传递', nanoid: nanoid()},
    ]
  }
]



// WEBPACK FOOTER //
// ./src/views/technology/data.js